import React, {Fragment, PureComponent} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import AskReinforcement from '../../../components/AskReinforcement/AskReinforcement.jsx';
import CalendlyButton from '../../../components/CalendlyButton/CalendlyButton.jsx';
import Header from '../../../components/Header/Header.jsx';
import Landing from '../Landing.jsx';
import OurDifferences from '../../../components/OurDifferences/OurDifferences.jsx';
import OurJobs from '../../../components/OurJobs/OurJobs.jsx';
import References from '../../../components/References/References.jsx';

import {generate} from '../../../routes.js';
import conf from '../../../conf.js';

import header from './images/header.jpg?size=600';
import person from './images/person.svg';
import shield from './images/shield.svg';
import engineeringImg from './images/engineering.png?size=600';
import financeImg from './images/finance.jpg?size=600';
import purchaseImg from './images/purchase.jpg?size=600';
import hrImg from './images/hr.jpg?size=600';

const headerBrief = <Fragment>
  <p>
    Que vous recherchiez <strong>un expert, un renfort pour vos équipes ou un manager de transition Achats, Finance,
    Ingénierie ou RH</strong>, Twineeds est la plateforme qu'il vous faut.
  </p>
  <p>Accédez directement à nos consultants ou consultez nous directement avec votre recherche.</p>
</Fragment>;

const title = "Twineeds | Trouvez rapidement un consultant expert";
const description = "Partagez vos besoins en consultants experts et accédez à des profils qualifiés en ingénierie et fonctions support (Achats, Supply, Finance, RH).";

const ourJobsItems = [
  {
    title: 'Achats et Supply Chain',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour du monde des achats (<strong>' +
      'acheteurs, SRM, contract managers</strong> etc.) mais également de la Supply Chain (<strong>logisticien, ' +
      'responsable transport, gestionnaire de flux, chef de projet supply chain</strong> etc.)</p>',
    img: purchaseImg.src,
    imgAlt: 'Équipe concentrée sur un projet stratégique devant un PC'
  },
  {
    title: 'Finance',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour du monde de la Finance : <strong>DAF, ' +
      'trésorier, contrôleur de gestion, consolideur, comptabilité</strong> etc.</p>',
    img: financeImg.src,
    imgAlt: 'Consultant finance conseille une entreprise autour d\'un bureau'
  },
  {
    title: 'Ingénierie Technique',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> dans tous les domaines de l\'ingénierie ' +
      '(hors IT) : <strong>ingénieur méthode, industrialisation, génie civil, responsable QHSE</strong> etc.</p>',
    img: engineeringImg.src,
    imgAlt: 'Consultants ingénieurs en ingénierie mécanique collaborant sur un projet technique'
  },
  {
    title: 'Ressources Humaines',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> sur les problématiques liées aux Ressources ' +
      'Humaines : <strong>DRH, responsable paie, chargé(e) projet SIRH, chargé(e) de recrutement</strong> etc.</p>',
    img: hrImg.src,
    imgAlt: 'Consultante experimentée conseille une entreprise devant un PC'
  }
];

class LandingCompany extends PureComponent {
  render() {
    const headerCtas = <Fragment>
      <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Proposer une mission</Link>
      <CalendlyButton className="btn btn-secondary" meetingUrl={conf.calendly.do}>Être rappelé(e)</CalendlyButton>
    </Fragment>;

    return <Landing
      className="landing-company"
      helmet={{title, description}}
    >
      <Header
        brief={headerBrief}
        ctas={headerCtas}
        imageAlt={'Consultant indépendant conseille entreprise en regardant des documents'}
        imageSrc={header.src}
        title="Besoin de spécialistes des fonctions support&nbsp;?"
      />

      <div className="bg-light">
        <References className="container text-center py-5"/>
      </div>

      <OurJobs items={ourJobsItems}/>

      <div className="bg-light">
        <AskReinforcement/>
      </div>

      <OurDifferences specificDifference={
        <Fragment>
          <strong>Une large gamme de compétences sur les fonctions corporate</strong>, utile dans le cadre de
          transformations/sujets transverses.
        </Fragment>
      }/>

      <div className="bg-light">
        <section id="benefits" className="container py-5">
          <div className="row text-center">
            <div className="col-md-6 pl-md-5 mb-4 mb-md-0">
              <img className="mb-4" src={person} alt={''}/>
              <h3>100% de consultants qualifiés</h3>
              <p>
                Tous nos consultants ont été rencontrés et qualifiés par des professionnels de LEUR métier, afin de
                vous assurer de la réelle adéquation entre vos besoins et leurs qualifications.
              </p>
            </div>
            <div className="col-md-6 pr-md-5 mb-4 mb-md-0">
              <img className="mb-4" src={shield} alt={''}/>
              <h3>Quels sont les risques de requalification ?</h3>
              <p>
                Vous êtes parfaitement protégés contre les risques de prêt de main d'œuvre illicite et de délit de
                marchandage !
              </p>
              <Link className="btn btn-primary" to={generate({name: 'legal'})}>En savoir plus</Link>
            </div>
          </div>
        </section>
      </div>
    </Landing>;
  }
}

export default connect(
  state => ({
    universes: state.universe.universes,
  })
)(LandingCompany);
